import React from "react";
import { Helmet } from "react-helmet-async";
import { ldJson } from "./consts.ts";

export const VenueSelectorPageHead: React.FC = () => {
  const title = `CinemaGuide - Discover Every Film Showing In Cinemas Near You`;
  const description =
    "Discover every movie listing, showtime, and cinema near you. Enter your location, select the cinemas you'd like to see showtimes for, then see what's on. Book tickets and plan cinema trips.";
  const pageUrl = "https://cinemaguideireland.com/cinema-select";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={pageUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={pageUrl} />
      <script type="application/ld+json">{ldJson(pageUrl)}</script>
      <script
        defer
        src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBo1vYSnz1MoWTH7xP__lBBYpvFUqJaPeE&libraries=places&callback=initMaps"
      />
    </Helmet>
  );
};
